import { render, staticRenderFns } from "./CandleStick.vue?vue&type=template&id=1de5aea4&scoped=true&"
import script from "./CandleStick.vue?vue&type=script&lang=js&"
export * from "./CandleStick.vue?vue&type=script&lang=js&"
import style0 from "./CandleStick.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de5aea4",
  null
  
)

export default component.exports